function passwordCheck() {
  return {
    require: "ngModel",
    link: function (scope, elem, attrs, ctrl) {
      const firstPassword = "#" + attrs.passwordCheck;
      elem.add(firstPassword).on("keyup", function () {
        scope.$apply(function () {
          const v = elem.val() === $(firstPassword).val();
          ctrl.$setValidity("passwordMatch", v);
        });
      });
    },
  };
}

export default passwordCheck;
